import { h } from 'preact'
import Button from "../ui-components/Button";

interface Props {
    'phrases': {
        'Forum': {
            "unsubscribe.from.invite.title": string,
            "unsubscribe.from.invite.body": string,
            "unsubscribe.from.invite.button": string
        }
    }
}

const Unsubscribe = ({ phrases } : Props) => {
    return (
        <div className='unsubscribe-wrapper'>
            <div className='unsubscribe-title'>
                { phrases.Forum['unsubscribe.from.invite.title'] }
            </div>
            <div className='unsubscribe-body'>
                { phrases.Forum['unsubscribe.from.invite.body'] }
            </div>
            <div className='unsubscribe-action'>
                <a href={"/"}><Button primary title={ phrases.Forum['unsubscribe.from.invite.button']}/></a>
            </div>
        </div>
    )
}

export default Unsubscribe
